// Sprint CAL-1 — componenti comuni per chiudere (nota obbligatoria) e rimandare un'attività: finestra dell'attività,
// To do List e pagina Attività (CAL-1b) usano questi, mai una copia.
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { toast } from "sonner";
import { History } from "lucide-react";
import { errore, CampoNota } from "@/pages/crm/crmComuni";
import { MSG_LEAD_SENZA_TEL } from "./calendarioComuni";

export function ChiudiAttivita({ ev, onChiudi, onFatto }) {
  const [nota, setNota] = useState("");
  const [prossimo, setProssimo] = useState(false);
  const [p, setP] = useState({ giorno: "", ora: "", nota: "" });
  const conRichiamo = ev.tipo === "chiamata" && !!ev.opportunita_id;
  const conferma = async () => {
    const body = { esito: nota.trim() };
    if (conRichiamo && prossimo) {
      body.prossimo_richiamo = { inizio: `${p.giorno}T${p.ora || "00:00"}`, tutto_il_giorno: !p.ora, nota: p.nota };
    }
    try { await api.post(`/calendario/eventi/${ev.id}/fatto`, body); toast.success("Segnato fatto"); onFatto(); }
    catch (e) { setErr(errore(e)); }
  };
  // Sprint CAL-2 — il prossimo richiamo chiede il telefono nel contatto della lead: il messaggio resta in questa finestra
  const [err, setErr] = useState(null);
  const senzaTel = conRichiamo && prossimo && ev.contatto_lead && !ev.contatto_lead.telefoni?.length;
  const msg = senzaTel ? MSG_LEAD_SENZA_TEL : err;
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onChiudi(); }}>
      <DialogContent className="max-w-md" data-testid="cal-chiudi-dialog">
        <DialogHeader><DialogTitle>Segna fatto: {ev.titolo}</DialogTitle></DialogHeader>
        <Label>Nota di chiusura *</Label>
        <CampoNota value={nota} onChange={setNota} placeholder="Com'è andata?" testid="cal-chiudi-nota" />
        {conRichiamo && <div className="space-y-2 border-t pt-2">
          <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={prossimo} onChange={(e) => setProssimo(e.target.checked)}
            data-testid="cal-chiudi-prossimo" /> Fissa il prossimo richiamo</label>
          {prossimo && <div className="grid grid-cols-2 gap-2">
            <Input type="date" value={p.giorno} onChange={(e) => setP({ ...p, giorno: e.target.value })} data-testid="cal-chiudi-prossimo-giorno" />
            <Input type="time" value={p.ora} onChange={(e) => setP({ ...p, ora: e.target.value })} data-testid="cal-chiudi-prossimo-ora" />
            <Input className="col-span-2" placeholder="Nota (facoltativa)" value={p.nota} onChange={(e) => setP({ ...p, nota: e.target.value })}
              data-testid="cal-chiudi-prossimo-nota" /></div>}
        </div>}
        {msg && <div className="text-sm text-rose-700" data-testid="cal-chiudi-errore">{msg}{" "}
          {msg === MSG_LEAD_SENZA_TEL && ev.contatto_lead?.id && <Link to={`/crm/contatti/${ev.contatto_lead.id}`} className="font-medium underline"
            data-testid="cal-chiudi-apri-contatto">Apri il contatto</Link>}</div>}
        <DialogFooter>
          <Button variant="outline" onClick={onChiudi} data-testid="cal-chiudi-annulla">Annulla</Button>
          <Button onClick={conferma} disabled={!nota.trim() || (conRichiamo && prossimo && !p.giorno) || senzaTel} className="bg-[#0F4C81] hover:bg-[#0c3d68]"
            data-testid="cal-chiudi-conferma">Conferma</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

// «Domani», «Fra una settimana», «Scegli data…»: sposta solo il giorno, l'ora resta (senza scadenza non compare).
// Sprint CAL-1b — menu in un riquadro sopra la pagina: sempre intero, anche nelle finestre e sul telefono
// Sprint CAL-1c — `icona` (facoltativa): orologio con freccia al posto della scritta, «Rimanda» al passaggio del mouse e in testa al menu
export function Rimanda({ ev, onFatto, testid = "cal-rimanda", icona = false }) {
  const [aperto, setAperto] = useState(false);
  const [data, setData] = useState("");
  if (!ev.inizio || ev.fatto) return null;
  const vai = async (quando, d) => {
    try { await api.post(`/calendario/eventi/${ev.id}/rimanda`, { quando, data: d || null }); toast.success("Rimandata"); setAperto(false); onFatto(); }
    catch (e) { toast.error(errore(e)); }
  };
  return (
    <span className="inline-flex" data-testid={testid}>
      <Popover open={aperto} onOpenChange={setAperto}>
        <PopoverTrigger asChild>{icona
          ? <button type="button" title="Rimanda" aria-label="Rimanda" className="rounded border p-0.5 text-slate-600 hover:bg-slate-100" data-testid={`${testid}-apri`}><History className="h-3.5 w-3.5" /></button>
          : <Button size="sm" variant="outline" data-testid={`${testid}-apri`}>Rimanda</Button>}</PopoverTrigger>
        <PopoverContent align="end" collisionPadding={8} className="w-60 p-2 space-y-1" data-testid={`${testid}-menu`}>
          {icona && <div className="px-1 text-xs font-semibold text-slate-700" data-testid={`${testid}-etichetta`}>Rimanda</div>}
          <Button size="sm" variant="ghost" className="w-full justify-start" onClick={() => vai("domani")} data-testid={`${testid}-domani`}>Domani</Button>
          <Button size="sm" variant="ghost" className="w-full justify-start" onClick={() => vai("settimana")} data-testid={`${testid}-settimana`}>Fra una settimana</Button>
          <div className="text-xs text-slate-500 px-1">Scegli data…</div>
          <div className="flex gap-1 items-center">
            <Input type="date" value={data} onChange={(e) => setData(e.target.value)} data-testid={`${testid}-data`} />
            <Button size="sm" disabled={!data} onClick={() => vai("data", data)} data-testid={`${testid}-data-ok`}>OK</Button></div>
        </PopoverContent>
      </Popover>
    </span>
  );
}
